// extracted by mini-css-extract-plugin
export default {"active":"TabSelectBtn_active__1gl9I"};